import fetch from '@/utils/fetch'

/**
 * 商品详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getCourseDetails(data = {}) {
  return fetch({
    url: '/api_cms/service/cms/w/xcx/course/view',
    method: 'post',
    data
  })
}

export function getNote(data = {}) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/webapp/note/data_type/time',
    method: 'post',
    data
  })
}
